import { ImagePicture } from 'approot/shared/images/images';

import contentEyeAvif from './image-content-eye.avif';
import contentEyeWebp from './image-content-eye.webp';
import contentEyePng from './image-content-eye.png';

const ImageContentEye = ({
  width,
  altText,
}: {
  width?: number;
  altText?: string;
}) => (
  <ImagePicture
    style={width ? { width, height: width } : undefined}
    altText={altText}
    avif={{ path: contentEyeAvif }}
    webp={{ path: contentEyeWebp }}
    png={{ path: contentEyePng }}
  />
);

export default ImageContentEye;
